var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3334 5.3335C13.6401 5.3335 10.6534 8.32016 10.6534 12.0135H10.6668C10.674 12.7437 11.2682 13.3335 12.0001 13.3335C12.732 13.3335 13.3262 12.7437 13.3333 12.0135H13.3335C13.3406 12.7437 13.9348 13.3335 14.6667 13.3335C15.3987 13.3335 15.9929 12.7437 16 12.0135H16.0001V21.3335C16.0001 22.0668 16.6001 22.6668 17.3334 22.6668C18.0667 22.6668 18.6667 22.0668 18.6667 21.3335V12.0135H18.6668C18.674 12.7437 19.2682 13.3335 20.0001 13.3335C20.732 13.3335 21.3262 12.7437 21.3334 12.0135H21.3335C21.3406 12.7437 21.9348 13.3335 22.6667 13.3335C23.3987 13.3335 23.9929 12.7437 24 12.0135H24.0134C24.0134 8.32016 21.0267 5.3335 17.3334 5.3335ZM4.00008 25.3335H19.4401L26.8267 17.9468C27.0934 17.6935 27.4267 17.5602 27.7734 17.5602C28.1067 17.5602 28.4534 17.6935 28.7201 17.9468C29.2401 18.4668 29.2401 19.3068 28.7201 19.8268L21.1734 27.3735C21.1382 27.4069 21.1018 27.4383 21.0644 27.4675C20.8205 27.7905 20.4336 28.0002 20.0001 28.0002H4.00008C3.26675 28.0002 2.66675 27.4002 2.66675 26.6668C2.66675 25.9335 3.26675 25.3335 4.00008 25.3335Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackages);
export default __webpack_public_path__ + "static/media/packages.e1f752b2ba9172eea5aa9197349267ce.svg";
export { ForwardRef as ReactComponent };